import { MaterialSlot } from "./MaterialSlot";
import { MaterialResources } from "@/state/MaterialResources";

export const getSuitableMaterials = (
    materialSlot: MaterialSlot,
    materials: Record<string, MaterialResources>
): MaterialResources[] => {
    const allMaterials = Object.values(materials);

    if (
        !materialSlot ||
        (materialSlot.type === "fixed" && !materialSlot.materialName) ||
        (materialSlot.type === "selectable" &&
            materialSlot.groups.length === 0 &&
            materialSlot.materialNames.length === 0)
    ) {
        return allMaterials;
    }

    if (materialSlot.type === "fixed") {
        return [materials[materialSlot.materialName]];
    }

    return allMaterials.filter(
        (material) =>
            materialSlot.materialNames.includes(material.config.name) ||
            materialSlot.groups.some((group) => material.config.groups.includes(group))
    );
};
